import TimerFactory from './Factory'

exports.TimerFactory = TimerFactory
